"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_parser_1 = require("@dynamynd/content-parser");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var index_1 = require("../index");

var Rectangle =
/** @class */
function (_super) {
  __extends(Rectangle, _super);

  function Rectangle() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handlePress = function () {
      if (!_this.props.disabled && _this.props.action) {
        _this.props.action();
      }
    };

    return _this;
  }

  Rectangle.prototype.render = function () {
    var _a = this.props,
        shouldRenderMascot = _a.shouldRenderMascot,
        text = _a.text,
        mascotConfig = _a.mascotConfig;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(RectangleOuterContainer, __assign({}, this.props), shouldRenderMascot && react_1.default.createElement(index_1.ImageOwlTips, {
      top: mascotConfig.top,
      bottom: mascotConfig.bottom,
      left: mascotConfig.left,
      rotate: mascotConfig.rotate
    }), react_1.default.createElement(RectangleContainer, __assign({
      onPress: this.handlePress
    }, this.props), react_1.default.createElement(RectangleText, null, react_1.default.createElement(Message, null, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: text
    })))), react_1.default.createElement(RectangleRotated, __assign({}, this.props))));
  };

  return Rectangle;
}(react_1.default.Component);

exports.Rectangle = Rectangle;
var RectangleOuterContainer = styled_components_1.default(function (_a) {
  var shouldRenderMascot = _a.shouldRenderMascot,
      mascotConfig = _a.mascotConfig,
      rest = __rest(_a, ["shouldRenderMascot", "mascotConfig"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    z-index: 1;\n    height: 208px;\n    width: 185px;\n    margin: 0 25px 25px 0;\n    border-radius: 15px;\n    background-color: ", ";\n"], ["\n    position: relative;\n    z-index: 1;\n    height: 208px;\n    width: 185px;\n    margin: 0 25px 25px 0;\n    border-radius: 15px;\n    background-color: ", ";\n"])), function (props) {
  return props.backgroundcolor ? props.backgroundcolor : props.theme.colors.main.purple;
});
var RectangleRotated = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    transform: rotate(", "deg);\n    margin: 0 25px 25px 0;\n    height: 208px;\n    width: 185px;\n    border-radius: 15px;\n    background-color: ", ";\n    opacity: 0.5;\n"], ["\n    position: absolute;\n    z-index: 1;\n    transform: rotate(", "deg);\n    margin: 0 25px 25px 0;\n    height: 208px;\n    width: 185px;\n    border-radius: 15px;\n    background-color: ", ";\n    opacity: 0.5;\n"])), function (props) {
  return props.degree ? props.degree : "";
}, function (props) {
  return props.backgroundcolor ? props.backgroundcolor : props.theme.colors.main.purple;
});
var RectangleContainer = styled_components_1.default(function (_a) {
  var shouldRenderMascot = _a.shouldRenderMascot,
      mascotConfig = _a.mascotConfig,
      rest = __rest(_a, ["shouldRenderMascot", "mascotConfig"]);

  return react_1.default.createElement(react_native_1.TouchableWithoutFeedback, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 24px 12px;\n    height: 240px;\n    width: 190px;\n    border-radius: 15px;\n    background-color: ", ";\n    position: relative;\n"], ["\n    padding: 24px 12px;\n    height: 240px;\n    width: 190px;\n    border-radius: 15px;\n    background-color: ", ";\n    position: relative;\n"])), function (props) {
  return props.backgroundcolor ? props.backgroundcolor : props.theme.colors.main.purple;
});
var Message = styled_components_1.default(react_native_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    color: #ffffff;\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    cursor: default;\n"], ["\n    color: ", ";\n    color: #ffffff;\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    cursor: default;\n"])), function (props) {
  return props.theme.colors.white;
});
var RectangleText = styled_components_1.default(react_native_1.Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    z-index: 2;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    z-index: 2;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;